import {gql} from "apollo-boost";

export const assignToMeMutation =  gql`
mutation AssignToMe ($ticketId: ID!, $allowOverride: Boolean) { 
  assignToMe(ticketId: $ticketId, allowOverride: $allowOverride) 
}
  `
